export default __webpack_public_path__ + "static/media/ai.3a4e3699.svg";